import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Row, Col } from "antd";
import Field from "components/Input/Field";
import { OperacaoEnum } from "core/resources/enums/conta";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import SelectContaCategoria from "ui/components/Input/SelectContaCategoria";
import SelectableButton from "components/Button/SelectableButton";
import colors from "resources/theme/colors";
import { FiltrosAdicionaisProps } from "../FiltrosAdicionais";
import SelectCentroDeCusto from "../../../../../../../../../components/Input/SelectCentroDeCusto/index";

function FiltrosAdicionaisBalancoFinanceiro({
  index,
  control,
}: FiltrosAdicionaisProps) {
  return (
    <Flex flexDir="column">
      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.search`}
            label="Busca"
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.contaCategoriaIds`}
            label="Contas categorias"
            render={({ field }) => <SelectContaCategoria {...field} />}
          />
        </Box>

        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.contaBancariaIds`}
            label="Contas bancárias"
            render={({ field }) => (
              <SelectContaBancaria {...field} mode="multiple" />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.centrosDeCustoIds`}
            label="Centros de custo"
            render={({ field }) => (
              <SelectCentroDeCusto mode="multiple" {...field} />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.operacao`}
            render={({ field }) => (
              <Flex gridGap={4}>
                <SelectableButton
                  selected={field.value === OperacaoEnum.Receita}
                  onClick={() => field.onChange(OperacaoEnum.Receita)}
                  onUnselect={() => field.onChange(undefined)}
                  rounded="full"
                  selectedColor={colors.blue300}
                  fontSize="14px"
                >
                  Receitas
                </SelectableButton>
                <SelectableButton
                  selected={field.value === OperacaoEnum.Despesa}
                  onClick={() => field.onChange(OperacaoEnum.Despesa)}
                  onUnselect={() => field.onChange(undefined)}
                  rounded="full"
                  selectedColor={colors.green500}
                  fontSize="14px"
                >
                  Despesas
                </SelectableButton>
              </Flex>
            )}
          />
        </Box>
      </Box>
    </Flex>
  );
}

export default FiltrosAdicionaisBalancoFinanceiro;
